import { DraftOptionLeg } from '#/unified-rfqs/ui/rfq-builder/types';
import { UnifiedInstruments } from '#/unified-rfqs/ui/instruments/types';
import { areExpirationsEqual } from './expiration-utils';

export function instrumentView(
  optionKind: DraftOptionLeg['optionKind'],
  expiration: DraftOptionLeg['expiration'],
  strike: DraftOptionLeg['strike'],
  instruments: UnifiedInstruments['optionInstruments'],
) {
  const instrument = instruments.find(
    (ins) =>
      optionKind === ins.option_kind &&
      areExpirationsEqual(expiration, ins.expiration) &&
      strike === ins.strike,
  );
  return [instrument?.name, instrument?.id] as const;
}
